import { Link } from "react-router-dom";

// Official SYNC bolt (transparent PNG, black bg removed) — used everywhere.
export const SYNC_MARK_URL = "/sync-logo.png";

export default function Logo({ variant = "full", size = "md", className = "", asLink = true }) {
  const sizes = {
    sm: { icon: 26, word: "text-lg tracking-[0.18em]", tag: "text-[8px] tracking-[0.35em]" },
    md: { icon: 36, word: "text-2xl tracking-[0.18em]", tag: "text-[9px] tracking-[0.35em]" },
    lg: { icon: 64, word: "text-5xl tracking-[0.12em]", tag: "text-[11px] tracking-[0.4em]" },
  };
  const s = sizes[size] || sizes.md;

  const content = (
    <span className={`inline-flex items-center gap-3 ${className}`} data-testid={`logo-${variant}`}>
      <img
        src={SYNC_MARK_URL}
        alt="SYNC"
        style={{ height: s.icon, width: "auto" }}
        className="object-contain select-none"
        draggable={false}
      />
      {variant !== "mark" && (
        <span className="flex flex-col leading-none">
          <span className={`font-anton uppercase text-chalk ${s.word}`}>SYNC</span>
          {variant === "full" && (
            <span className={`font-mono uppercase text-pulse mt-0.5 ${s.tag}`}>MOVE WITH THE BEAT</span>
          )}
        </span>
      )}
    </span>
  );

  return asLink ? <Link to="/" data-testid="logo-link">{content}</Link> : content;
}
